module.exports = __webpack_public_path__ + "static/media/MASTER F.F.2eec7ae8.png";